// Build-time feature flags for cloak-file-web.
// Toggle these constants to show/hide UI features, then rebuild/restart the app.

// Show the "Enterprise Login" link on the password login page (/cloak/login).
// Set to false to hide it for deployments that don't use the enterprise gateway.
export const SHOW_ENTERPRISE_LOGIN = true;

// --- Web push (FCM) for license-solicitation events -------------------------
// Fill in from the Firebase console (project `cloak-encrypt`):
//   - FIREBASE_CONFIG: project settings → General → "Your apps" → Web app
//     (create one if none exists) → SDK setup config object.
//   - FIREBASE_VAPID_KEY: project settings → Cloud Messaging →
//     Web configuration → Web Push certificates → key pair (public key).
// Keep the config in sync with public/firebase-messaging-sw.js.
// While left empty, web push is disabled and the app stays on the existing
// fetch-on-login / manual-refresh behavior.
export const FIREBASE_CONFIG = {
	apiKey: 'AIzaSyD7ON8B24fCGpJEpqbtDUjgNpkqYYEmPTo',
	authDomain: 'cloak-encrypt.firebaseapp.com',
	projectId: 'cloak-encrypt',
	messagingSenderId: '959307525931',
	appId: '1:959307525931:web:8b3d589fa659f0dfd65f6e',
};
export const FIREBASE_VAPID_KEY = 'BLtCnFFIU-TFh--oyrSu9C91jVhJC3rh1KOWvRppNfbudDCYieu6gMsHG5rKt4OpnRdaHvj8d0-LZrRBGZmXDxg';
// Served from public/ under the /cloak/ mount (see webpack.config.js static mounts).
export const PUSH_SW_PATH = '/cloak/public/firebase-messaging-sw.js';
